import React from 'react';
import { Heading04 } from '@uds/typography';
import { useTheme, Colorway } from '@uds/theme-utils';

import useStylesheet from './WideTable.stylesheet';
import WideCell from './WideCell';
import WideTableRow from './WideTableRow';
import { CellProps } from './Cell';

const isOdd = (i: number) => i % 2 === 1;
const isLast = (i: number, n: number) => i + 1 === n;

interface OuterProps {
  colorway: Colorway;
  head: Array<CellProps>;
  body: Array<Array<CellProps>>;
  hBaseline?: number;
}

declare const i: number;
declare const cell: CellProps;
declare const row: Array<CellProps>;

const PureWideTable = ({ colorway, head, body, hBaseline = 1 }: OuterProps) => {
  const { theme } = useTheme();
  const { styles } = useStylesheet({
    theme,
  });
  return (
    <div style={styles.table}>
      <div style={styles.theadRow}>
        <For each="cell" of={head} index="i">
          <div style={styles.cell} key={i}>
            <Heading04 depth={hBaseline}>
              <WideCell colorway={colorway} cell={cell} key={i} first={i === 0} last={i === head.length - 1} />
            </Heading04>
          </div>
        </For>
      </div>
      <For each="row" of={body} index="i">
        <WideTableRow colorway={colorway} row={row} isOdd={isOdd(i)} isLast={isLast(i, body.length)} key={i} />
      </For>
    </div>
  );
};

PureWideTable.displayName = 'WideTable';

export default PureWideTable;
